module.exports = __webpack_public_path__ + "static/media/logo-small.ad46af03.svg";